import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }
  
  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  private _storage: Storage | null = null;
    private initPromise: Promise<void> | null = null;
    private cache = new Map<string, any>();
    private cache$ = new BehaviorSubject<Map<string, any>>(this.cache);

    constructor(private storage: Storage) {
      this.initPromise = this.init();
    }

    private async ensureStorageReady(): Promise<void> {
      if (this._storage) {
        return;
      }
      if (!this.initPromise) {
        this.initPromise = this.init();
      }
      await this.initPromise;
    }

    async init(): Promise<void> {
      this._storage = await this.storage.create();
  }

  async setItemIonic(key: string, value: any): Promise<void> {
    await this.ensureStorageReady();
    await this._storage!.set(key, value); 
  }

  async getItemIonic(key: string): Promise<any> {
    await this.ensureStorageReady();
    return await this._storage!.get(key);
  }

    async removeItemIonic(key: string): Promise<void> {
      await this.ensureStorageReady();
      await this._storage!.remove(key);
  }

    async clearIonic(): Promise<void> {
      await this.ensureStorageReady();
      await this._storage!.clear();
    }

  }
